export default __webpack_public_path__ + "static/media/question.3722e6d9.svg";